<div class="terms-content-wrapper">
  <p class="terms-last-updated mt-50" *ngIf="termsData.useDate">
    Last updated on: {{ termsData.lastUpdated }}
  </p>

  <div class="terms-content">
    <div *ngFor="let term of termsData.terms" class="mt-40">
      <div class="terms-content-paragraph">
        <div *ngFor="let paragraph of term.paragraph">
          <ng-container [ngSwitch]="paragraph.tagType">
            <h3 *ngSwitchCase="'h3'" [ngClass]="paragraph.class">
              {{ paragraph.text }}
            </h3>
            <p *ngSwitchDefault [ngClass]="paragraph.class">
              {{ paragraph.text }}
            </p>
            <ng-container *ngSwitchCase="'list'">
              <div *ngFor="let listItem of paragraph.textList">
                <p class="terms-description">{{ listItem }}</p>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'checkedList'">
              <div class="d-flex flex-column gap-size-15">
                <div *ngFor="let checkedItem of paragraph.checkedList" class="d-flex gap-size-15 align-items-center">
                  <img src="assets/icons/check.svg" alt="checkIcon" />
                  <p class="terms-description">{{ checkedItem }}</p>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
